// @flow

import * as React from 'react';
import { useRifm } from 'rifm';
import { OutlinedInput } from '@material-ui/core';
import { useNumberFormat } from '../hooks/number-format.js';

type Props = {|
  decimalScale?: number,
  align?: 'left' | 'center' | 'right',
  startAdornment?: React.Node,
  endAdornment?: React.Node,
  value: string,
  onChange: string => void,
  onBlur?: () => void,
  onFocus?: () => void,
  // TODO remove after migration to specific rifm components
  placeholder?: string,
  maxLength?: number,
  inputRef?: React.Ref<any>,
  autoFocus?: boolean,
  'aria-label'?: string,
  onKeyDown?: (SyntheticKeyboardEvent<HTMLInputElement>) => void,
  allowNegative?: boolean,
  error?: boolean,
|};

export const NumberInput = (props: Props): React.Node => {
  const { accept, parse, format } = useNumberFormat({
    scale: props.decimalScale,
    allowNegative: props.allowNegative,
  });
  const rifm = useRifm({
    accept,
    format,
    value: props.value,
    onChange: formatted => props.onChange(parse(formatted)),
  });

  return (
    <OutlinedInput
      labelWidth={0}
      css={{
        paddingLeft: 0,
        paddingRight: 0,
        '.MuiOutlinedInput-input': {
          textAlign: props.align,
        },
      }}
      startAdornment={props.startAdornment}
      endAdornment={props.endAdornment}
      placeholder={props.placeholder}
      inputProps={{
        type: 'tel',
        maxLength: props.maxLength,
        'aria-label': props['aria-label'],
      }}
      value={rifm.value}
      onChange={rifm.onChange}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      inputRef={props.inputRef}
      autoFocus={props.autoFocus}
      onKeyDown={props.onKeyDown}
      error={props.error}
    />
  );
};
